<template>
  <link
    rel="stylesheet"
    href="https://cdn.jsdelivr.net/gh/devicons/devicon@latest/devicon.min.css"
  />
  <div class="content-section" id="tech-stacks">
    <section-title>I've worked with:</section-title>
    <div class="content-section__body">
      <center>
        <i>Languages:</i>
        <div class="stack-icon__container">
          <tech-stack-icon
            v-for="tech in languages"
            :key="tech.name"
            :stack="tech"
          />
        </div>

        <i>Stacks & Frameworks:</i>
        <div class="stack-icon__container">
          <tech-stack-icon
            v-for="tech in stacks"
            :key="tech.name"
            :stack="tech"
          />
        </div>

        <i>Other Proficiencies:</i>
        <div class="stack-icon__container">
          <tech-stack-icon
            v-for="tech in others"
            :key="tech.name"
            :stack="tech"
          />
        </div>

        <!--
        <br />

        <v-row align="start" justify="center">
          <v-col xs="11" lg="10" xl="9">
            <codersrank-skills-chart
              :username="codersrankUsername"
              tooltip
              labels
              legend
            ></codersrank-skills-chart>
          </v-col>
        </v-row>
        -->
      </center>
    </div>
  </div>
</template>

<script>
import baseData from 'data/base.json';
import portfolioData from 'data/dev-portfolio.json';
import TechStackIcon from '@/components/utilities/TechStackIcon';
import SectionTitle from '@/components/utilities/SectionTitle.vue';

export default {
  name: 'TechStacks',

  components: {
    TechStackIcon,
    SectionTitle,
  },

  data: () => ({
    codersrankUsername: baseData.githubUsername,
    languages: portfolioData.techStacks.languages,
    stacks: portfolioData.techStacks.stacks,
    others: portfolioData.techStacks.others,
  }),
};
</script>

<style scoped>
.stack-icon__container {
  font-size: 3.5em;
}
</style>
